import * as types from '@/assets/mutations-types.ts';
import axios from 'axios';

export default {
  state: {
    name: null,
    email: null,
    headers: null,
    main_menu: null,
    authenticated: false,
    overlay: false,
    show_error: false,
    type_error: null,
    text_error:null,
    is_admin: false,
    ver_expedientes: false,
    crear_expedientes: false,
    roles: [],
    expediente:[],
    menu_personal: [],
    menu_expediente: [],
  },
  gettters: {},
  mutations: {
    [types.SET_AUTH_USER](state, payload) {
      state.name = payload.name;
      state.email = payload.email;
      state.headers = payload.headers;
      state.main_menu = payload.main_menu;
      state.menu_personal = payload.menu_personal;
      state.menu_expediente = payload.menu_expediente;
      state.authenticated = true;
      state.roles = payload.roles;
    },
    [types.UNSET_AUTH_USER](state, payload) {
      state.name = null;
      state.email = null;
      state.headers = null;
      state.main_menu = [];
      state.menu_personal = [];
      state.menu_expediente = [];
      state.authenticated = false;
      state.roles = [];
    },
    [types.SET_OVERLAY](state) {
      state.overlay = true;
    },
    [types.UNSET_OVERLAY](state) {
      state.overlay = false;
    },
    [types.SHOW_ERROR](state, payload){
      state.show_error = payload.show_error;
      state.type_error = payload.type_error;
      state.text_error = payload.text_error;
    },
    [types.SET_ADMIN](state, payload) {
      state.is_admin = payload.is_admin;
      state.ver_expedientes = payload.ver_expedientes;
      state.crear_expedientes = payload.crear_expedientes;
    },
  },
  actions: {
    setAuthUser: ({commit, dispatch }, payload) => {
      //console.log(p);
      window.localStorage.setItem('email_user', payload.userName);
      commit({
        type: types.SET_AUTH_USER,
        name: payload.userName,
        email: payload.userName,
      });
    },
    unsetAuthUser: ({ commit }) => {
      commit({ type: types.UNSET_AUTH_USER });
    },
    REGISTER: ({ commit }, payload) => {
      // console.log("payload: REGISTER");
      return new Promise((resolve, reject) => {
        axios.post('accounts', payload)
          .then(({ data, status}) => {
            if (status === 200) {
              resolve(true);
            }
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    MAIN_MENU: ({ commit }, payload) => {
      //console.log(payload);
      return new Promise((resolve, reject) => {
        let token = window.localStorage.getItem('jwt_token');
        let headers = {
          'Authorization': 'Bearer ' + token,
          'Accept': 'application/json, text/plain, */*',
          'Content-Type': 'application/json',
        };
        axios.get('Carpeta/listar_carpetas', { headers })
          .then(({ data, status }) => {
            if (status === 200) {
              
              let email_user = window.localStorage.getItem('email_user');
              let main_menu = data.filter(v => (v.link != "carpeta_personal" && v.link != "expedientes"));

              if(main_menu.findIndex(v => v.link == 'documento') >= 0)  {
                main_menu.splice(main_menu.findIndex(v => v.link == 'documento'), 1);
              }
              if(main_menu.findIndex(v => v.link == 'deleted') >= 0) {
                main_menu.splice(main_menu.findIndex(v => v.link == 'deleted'), 1);
              }
              commit({
                type: types.SET_AUTH_USER,
                main_menu: main_menu,
                menu_personal: data.filter(v => v.link == "carpeta_personal"),
                menu_expediente: data.filter(v => v.link == "expedientes"),
                headers,
                name: email_user,
                email: email_user,
                roles: payload.roles,
              });

              commit({
                type: types.SET_ADMIN,
                is_admin: payload.roles.includes("Administrador"),
                ver_expedientes: payload.roles.includes("ver_expedientes"),
                crear_expedientes: payload.roles.includes("crear_expedientes"),
              });              
              resolve(true);
            }
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    SET_OVERLAY: ({ commit }) => {
      commit({ type: types.SET_OVERLAY });
    },
    UNSET_OVERLAY: ({ commit }) => {
      commit({ type: types.UNSET_OVERLAY});
    },
    SHOW_ERROR: ({commit, dispatch }, payload) => {
      commit({
        type: types.SHOW_ERROR,
        text_error: payload.text,
        show_error: payload.show,
        type_error: payload.type,
      });
    },
  },
};